<template>
    <div>
<!--
        <v-radio-group v-model="importType">
            <v-radio label="Vereine importieren" value="verein"></v-radio>
            <v-radio label="Spieler importieren" value="spieler"></v-radio>
        </v-radio-group>
        <input ref="dataConversion1" type="file" @change="dataConversion1" accept=".xls,.xlsx,.csv" />
        <p class="mt-5"><v-btn @click="processExcel()">Excel verarbeiten</v-btn></p>
        Anzahl von geladenen Zeilen: {{spielerListe.length}}
        <v-text-field label="von" type="number" v-model="von"></v-text-field>
        <v-text-field label="bis" type="number" v-model="bis"></v-text-field>
        <p class="mt-5"><v-btn @click="uploadVereine()">upload Vereine</v-btn></p>
        <p><v-btn @click="uploadSpielerListe()">upload Spieler</v-btn></p>
        <p class="mt-5"><v-btn @click="setDocIds()">Set Doc Ids</v-btn></p>
        <p class="mt-5"><v-btn @click="processChanges()">Process Changes in DB</v-btn></p>
        <p v-for="(mitglied, i) in excelPart1" :key="i">
            {{mitglied.id}} ---------- {{mitglied.spieler}}
        </p>
-->
        <!--<div>
            VEREINE:
            {{JSON.parse(JSON.stringify(vereine))}}
        </div>
        <div>
            SPIELER:
            <p >{{spielerListe[0]}}</p>
        </div>--><!--v-for="(spieler, i) in spielerListe" :key="i"-->
        <!--<algolia-download></algolia-download>-->
    </div>
</template>

<script>
    //import * as XLSX from 'xlsx';
    //import { db } from '../../services/db'
    //import {Spieler} from "../../services/data/spieler/spieler";
    //import TimeStamp from "../../services/timeStamp";
    //import {SportJahr} from "../../services/data/sportJahr";
    //import SPIELER_MEMBERSHIP_HANDLER from "../../services/data/spieler/spielerMembershipHandler";
    //import SPIELER_CHANGE_HANDLER from "../../services/data/spieler/spielerChangeHandler";
    //import AlgoliaDownload from "./algoliaDownload";

    export default {
        //components: {AlgoliaDownload},
        name: "data-conversion",
        data: () => ({
            errorMsg: '',
            importType: 'spieler',
            vereine: {},
            excelPart1: [],
            excelPart2: [],
            spielerListe: [],
            spielerDetails: [],
            sportJahr: null,
            von: 0,
            bis: 0,
        }),
        created(){
            //this.sportJahr = new SportJahr()
        },
        methods: {
            /*dataConversion1(e){
                console.log ("e", e);
                this.selectFile(e, 'dataConversion1')
            },
            selectFile(e, ref) {
                if (e.target.files.length > 0) {
                    this.errorMsg = '';
                    this.transformToJSON(e, e.target.files[0].name, ref);
                } else {
                    this.fileBase64 = '';
                }
            },
            transformToJSON(e, fileName, ref){
                this.$store.state.local.loader = true;
                console.log ("transformToJSON", fileName);
                let files = e.target.files, f = files[0];
                let reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        let data = new Uint8Array(e.target.result);
                        let workbook = XLSX.read(data, {type: 'array'});
                        let sheetName = workbook.SheetNames[0];
                        let worksheet = workbook.Sheets[sheetName];
                        // get data as array
                        let srcData = XLSX.utils.sheet_to_json(worksheet, {raw: true, defval: ""});//, dateNF: "ISO"
                        console.log ("srcData", JSON.parse(JSON.stringify(srcData)));
                        this.$refs[ref].value = null;
                        this.processContent(srcData, ref)
                    }
                    catch (e) {
                        console.error (e);
                        this.errorMsg = "err.noExcel";
                    }
                };
                reader.readAsArrayBuffer(f);
            },
            processContent(srcData, ref){
                console.log ("processContent", ref );
                if ( ref === 'dataConversion1' ) {
                    if ( this.importType === 'verein' ) {
                        this.prepareVereine(srcData);
                    } else {
                        this.excelPart1 = srcData;
                    }
                } else {
                    this.excelPart2 = srcData;
                }

                this.$store.state.local.loader = false;
            },
        // processExcel
            processExcel(){
                this.processExcel1();
                //this.processExcel2();
                this.setMemberships();
                console.log ("processExcel" );
            },
                processExcel1(){
                    let i = 2;
                    console.log ("excelPart1", this.excelPart1);
                    this.excelPart1.forEach( (row) => {
                        //console.log ("Excel 1: ", i);
                        let spieler = new Spieler();
                        spieler = this.setFromExcelPart1(spieler, row);
                        spieler.formatData();
                    // save data from Excel 1 temporarily
                        spieler.local.importTemp = {
                            lv: {id:  row['LV-Nummer'], sportart: parseInt(row['LV-Nummer'])>20 ? 'bowling' : 'classic'},
                            verein: row['Vereinsnummer'], passValidUntil: row['Pass-Ablaufjahr'] + '-06-30'
                        };

                    // set data especially from Import
                        spieler = this.processPassNumber(spieler, row);
                    // früher in 2ter Datei set anmeldeTag and gesperrtAb ...
                        if ( spieler.status === 'aktiv' && !row['Pass-Abmeldedatum'] ) {
                            spieler.dates.anmeldeTag = '2020-07-01';
                        } else if ( spieler.status === 'inaktiv' && row['Pass-Abmeldedatum'] ) {
                            const abmeldeDatum =  TimeStamp.getStringFromDotDate(row['Pass-Abmeldedatum']);
                            let abmeldeSportJahr = this.sportJahr.getSportJahrFromDate(abmeldeDatum);
                            spieler.dates.anmeldeTag = abmeldeSportJahr.from;
                            spieler.local.importTemp.passValidUntil = abmeldeSportJahr.until;
                            spieler.dates.gesperrtAb = abmeldeDatum;
                        } else {
                            console.error ("AKTIV/INAKTIV Status inkorrrekt: ", i, spieler );
                        }
                    // add to list
                        console.log ("XXXXXXXXXXXXXXXXXXXXXXX", spieler);
                        this.spielerListe.push(spieler);
                        i++;
                    })
                },
                    setFromExcelPart1(spieler, row){
                        spieler.titel = row['Titel'] ? row['Titel']:'';
                        spieler.vorname = row['Vorname'] ? row['Vorname']:'';
                        spieler.nachname = row['Familienname'] ? row['Familienname'].toUpperCase() : '';
                        spieler.private.geburtsdatum = row['Geburtsdatum'] ?
                            TimeStamp.getStringFromDotDate(row['Geburtsdatum']) : '';
                        spieler.status = row['Status'] ? row['Status']:'';
                        spieler.geschlecht = row['Geschlecht'] ? row['Geschlecht']:'';
                        spieler.private.nationalitaet = row['Nationalität'] ? row['Nationalität']:'';
                        spieler.private.plz = row['PLZ'] ? row['PLZ']:'';
                        spieler.private.ort = row['Ort'] ? row['Ort']:'';
                        spieler.private.strasse = row['Strasse'] ? row['Strasse'] : '';
                        spieler.private.telefon = row['Telefon'] ? row['Telefon'].toString() : '';
                        spieler.private.mobilTelefon = row['Mobil'] ? row['Mobil'].toString() : '';
                        spieler.private.eMail = row['Email'] ? row['Email']:'';
                    // ursprünglich 2. Datei
                        spieler.private.geburtsort = row['Geburtsort'] ? row['Geburtsort'] : '';
                        spieler.dsv = row['DSV'] ? TimeStamp.getStringFromDotDate(row['DSV']) : '';
                        spieler.ade = row['ADE'] ? TimeStamp.getStringFromDotDate(row['ADE']) : '';
                        spieler.attest = row['Ärztl. Attest'] ? TimeStamp.getStringFromDotDate(row['Ärztl. Attest']) : '';
                        return spieler;
                    },
                    processPassNumber(spieler, row) {
                        spieler.search.passStatus = ''; // passnr is already done
                        const passNr = row['Passnummer (6)'].toString();
                        spieler.local.importTemp.passNr = passNr; // save passnr for part 2
                        spieler.search.passNumbers = {[passNr]: true}; // set pass number in search
                        return spieler;
                    },

                setMemberships(){
                    for ( let i = 0; i < this.spielerListe.length; i++ ) {
                        //console.log ("Memberships 1: ", i, this.spielerListe[i]);
                        if ( this.spielerListe[i].local.importTemp.passValidUntil ) {
                            //console.log ("SET!!!!!!!!!!");
                            this.setTechnicalDataForImportedSpieler( this.spielerListe[i] );
                        } else {
                            console.log ("SPLICE!!!!!!!!!!", i, this.spielerListe[i]);
                            this.spielerListe.splice(i,1)
                        }
                    }
                },
                    setTechnicalDataForImportedSpieler( spieler ){
                        spieler.sportart = spieler.local.importTemp.lv.sportart;
                        const lvVerein = spieler.local.importTemp.lv.id + '' + spieler.local.importTemp.verein;
                        spieler.memberships = SPIELER_MEMBERSHIP_HANDLER.createNewSpieler (lvVerein,
                                                    spieler.dates.anmeldeTag, spieler.local.importTemp.passValidUntil);
                        spieler.memberships[0].passNr = spieler.local.importTemp.passNr; // set pass number in memberships
                        spieler.dates.firstSportTag = spieler.dates.anmeldeTag;
                        spieler.dates.lastSportTag = spieler.local.importTemp.passValidUntil;
                        if ( spieler.private.geburtsdatum ) {
                            spieler.dates.akJahr = parseInt(spieler.private.geburtsdatum.substr(0,4));
                            spieler.dates.akHJ = parseInt(spieler.private.geburtsdatum.substr(5,2)) <= 6 ? 1 : 2;
                        }
                        spieler.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( spieler.search, spieler.memberships, spieler.status );
                        spieler.search = SPIELER_CHANGE_HANDLER.search_setUserUnique(spieler.search, spieler );
                        spieler.search = SPIELER_CHANGE_HANDLER
                            .search_setBestaetigungenStatus(spieler.search, spieler.ade, spieler.dsv, spieler.status);
                    },
            
        // process Vereine
            prepareVereine(srcData){
                let lvNummer = 'LV-Nummer';
                let vereinsNr = 'Vereinsnummer';
                let vereinsName = 'Vereinsname';
                srcData.forEach( (row) => {
                    console.log ("row ", row);
                    let lvNr = row[lvNummer];
                    if ( this.vereine[lvNr] === undefined) {
                        this.vereine[lvNr] = {}
                    }
                    const vereinsKey = 'vereine.' + row[vereinsNr];
                    this.vereine[lvNr][vereinsKey] = {name: row[vereinsName]}
                });
                console.log ("this.vereine", this.vereine);
            },


        // uploads
            uploadVereine(){
                Object.keys(this.vereine).forEach( (lv) => {
                    const docRef = db.collection("landesverbaende").doc(lv);
                    return docRef.update(
                        this.vereine[lv],
                    )
                        .then(() => {
                            console.log("Document successfully updated!");
                        })
                        .catch((error) => {
                            // The document probably doesn't exist.
                            console.error("Error updating document: ", error);
                        });
                });
            },

            uploadSpielerListe(){
                if ( this.von === 0 || this.bis === 0 ) {
                    console.error('Bitte Bereich eingeben');
                    return
                }
                console.log ("this.spielerListe",this.spielerListe );
                for ( let i = this.von - 1; i < this.bis; i++ ) {
                    this.uploadSpieler(this.spielerListe[i])
                }
            },

                async uploadSpieler(spieler){
                    //spieler.setSearchData();
                    console.log ("spieler", spieler);
                    let reply = await spieler.saveNew('document');
                    if ( reply.successful ) {
                        spieler.private.id = reply.content;
                        reply = await spieler.private.saveNew('document');
                        if ( reply.successful ) {
                            // successful
                        } else {
                            // error handling
                        }
                    } else {
                        // error handling
                    }
                },


            setDocIds(){
                console.log ("setDocIds" );
                //let x = [{spieler: 'Jan Nicolas_EBERWEIN_2001-10-10'}];
                this.spielerListe=[];
                this.excelPart1.forEach( (mitglied) => {
                    console.log ("excelPart1" );
                    db.collection("spieler").where("search.userUnique", "==", mitglied.spieler)
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach((doc) => {
                                // doc.data() is never undefined for query doc snapshots
                                console.log(doc.id);
                                mitglied.id = doc.id;
                                this.spielerListe.push(mitglied)
                            });
                        })
                        .catch((error) => {
                            console.log("Error getting documents: ", error);
                        });
                });
            },
            processChanges(){
                //let x = [{spieler: 'Jan Nicolas_EBERWEIN_2001-10-10'}];
                this.spielerListe.forEach( (mitglied) => {
                    this.updateDB(mitglied.id)
                });
            },
                updateDB(docId){
                    db.collection("spieler").doc(docId).update({
                        ['dates.akHJ']: 2
                    })
                        .then(() => {
                            console.log("Document successfully updated!");
                        })
                        .catch((error) => {
                            // The document probably doesn't exist.
                            console.error("Error updating document: ", error);
                        });
                }*/
        },
    }
</script>

<style scoped>

</style>